import React from 'react';

interface LogoTextProps {
  text?: string;
  fontSize?: number;
  className?: string;
  style?: React.CSSProperties;
}

export function LogoText({
  text = 'SoulThread',
  fontSize = 28,
  className = '',
  style,
}: LogoTextProps) {
  return (
    <span className={`logo-text ${className}`} style={{ fontSize: fontSize + 'px', ...style }}>
      {text}
    </span>
  );
}

interface LogoTaglineProps {
  fontSize?: number;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export function LogoTagline({ fontSize = 14, className = '', style, children }: LogoTaglineProps) {
  return (
    <div className={`logo-tagline ${className}`} style={{ fontSize: fontSize + 'px', ...style }}>
      {children ?? 'Follow Your'}
    </div>
  );
}
